import React from 'react';
import PropTypes from 'prop-types';

class UserGuide extends React.Component {
  render() {
    return (
      <section className="user-guide">
        <dl className="grid__list grid__list--guide">
          <dt className="grid__item app--strong">Strong Appetite</dt>
          <dt className="grid__item app--qualified">
            Qualified; each risk considered on its merits
          </dt>
          {/* <dt className="grid__item app--mixed">Qualified; <em class="label-sm">GL+ Product = Green</em></dt> */}
          <dt className="grid__item app--limited">Limited or No Appetite</dt>
          <dt className="grid__item app--na">N/A</dt>
        </dl>
      </section>
    );
  }
}

export default UserGuide;



// WEBPACK FOOTER //
// ./src/components/UserGuide.js